export const kNIntoTons = (kN) => {
    return kN * 0.1019716213;
};

export const tonsTokN = (t) => {
    return t * 9.80665;
};

export const kNIntoTonsFloor = (kN) => {
    return Math.floor(kNIntoTons(kN));
};

export const kNIntoTonsRound = (kN) => {
    return Math.round(kNIntoTons(kN));
};

export const RoundTo1Decimal = (value) => {
    return Math.round(value * 10) / 10;
};

export const getShareInRage = (value, min, max) => {
    return (value - min) / (max - min);
};
